"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFreeze = require("react-freeze");
var _reactUi = require("@100mslive/react-ui");
var _reactSdk = require("@100mslive/react-sdk");
var _VideoTile = _interopRequireDefault(require("./VideoTile"));
var _ScreenshareTile = _interopRequireDefault(require("./ScreenshareTile"));
var _FeatureFlags = require("../services/FeatureFlags");
var _Pagination = require("./Pagination");
var _useAppConfig = require("./AppData/useAppConfig");
var _useUISettings = require("./AppData/useUISettings");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var List = function List(_ref) {
  var maxTileCount = _ref.maxTileCount,
    peers = _ref.peers,
    maxColCount = _ref.maxColCount,
    maxRowCount = _ref.maxRowCount,
    includeScreenShareForPeer = _ref.includeScreenShareForPeer;
  var _useTheme = (0, _reactUi.useTheme)(),
    aspectRatio = _useTheme.aspectRatio;
  var tileOffset = (0, _useAppConfig.useAppConfig)("headlessConfig", "tileOffset");
  var isHeadless = (0, _useUISettings.useIsHeadless)();
  var _useVideoList = (0, _reactSdk.useVideoList)({
      peers: peers,
      maxTileCount: maxTileCount,
      maxColCount: maxColCount,
      maxRowCount: maxRowCount,
      includeScreenShareForPeer: includeScreenShareForPeer,
      aspectRatio: aspectRatio,
      offsetY: getOffset({
        isHeadless: isHeadless,
        tileOffset: tileOffset
      })
    }),
    ref = _useVideoList.ref,
    pagesWithTiles = _useVideoList.pagesWithTiles;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  (0, _react.useEffect)(function () {
    // currentPageIndex should not exceed pages length
    if (page >= pagesWithTiles.length) {
      setPage(0);
    }
  }, [pagesWithTiles.length, page]);
  var useFreeze = _FeatureFlags.FeatureFlags.freezeVideoList();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.StyledVideoList.Root, {
    ref: ref,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledVideoList.Container, {
      children: pagesWithTiles && pagesWithTiles.length > 0 ? pagesWithTiles.map(function (tiles, pageNo) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFreeze.Freeze, {
          freeze: useFreeze && page !== pageNo,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledVideoList.View, {
            css: {
              left: (0, _reactUi.getLeft)(pageNo, page),
              transition: "left 0.3s ease-in-out"
            },
            children: tiles.map(function (tile, i) {
              var _tile$track, _tile$track2, _tile$peer, _tile$track3;
              return ((_tile$track = tile.track) === null || _tile$track === void 0 ? void 0 : _tile$track.source) === "screen" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenshareTile["default"], {
                width: tile.width,
                height: tile.height,
                peerId: tile.peer.id
              }, tile.track.id) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoTile["default"], {
                width: tile.width,
                height: tile.height,
                peerId: (_tile$peer = tile.peer) === null || _tile$peer === void 0 ? void 0 : _tile$peer.id,
                trackId: (_tile$track3 = tile.track) === null || _tile$track3 === void 0 ? void 0 : _tile$track3.id
              }, ((_tile$track2 = tile.track) === null || _tile$track2 === void 0 ? void 0 : _tile$track2.id) || tile.peer.id);
            })
          })
        }, pageNo);
      }) : null
    }), !isHeadless && pagesWithTiles.length > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pagination.Pagination, {
      page: page,
      setPage: setPage,
      numPages: pagesWithTiles.length
    }) : null]
  });
};
var VideoList = /*#__PURE__*/_react["default"].memo(List);
var getOffset = function getOffset(_ref2) {
  var offset = _ref2.offset,
    isHeadless = _ref2.isHeadless;
  if (!isHeadless || typeof offset !== "number") {
    return 32;
  }
  return offset;
};
var _default = VideoList;
exports["default"] = _default;